import { SENTRY_DOMAIN, SENTRY_MOBILE_DOMAIN } from 'shared/config'

const getReplaysPathByOrganizationId = (id: number | string) =>
  `/organizations/sentry/replays/?query=organization.id%3A${id}&statsPeriod=24h`

const getMobileReplaysPathByOrganizationId = (id: number | string) =>
  `/organizations/sentry/replays/?query=org_id%3A${id}&statsPeriod=24h`

export const getSentryReplaysLinkByOrganizationId = (id: number | string) => {
  if (!SENTRY_DOMAIN) return ''
  return `${SENTRY_DOMAIN}${getReplaysPathByOrganizationId(id)}`
}

export const getSentryMobileReplaysLinkByOrganizationId = (id: number | string) => {
  if (!SENTRY_MOBILE_DOMAIN) return ''
  return `${SENTRY_MOBILE_DOMAIN}${getMobileReplaysPathByOrganizationId(id)}`
}
